import React, { useState } from 'react';
import { useEffect } from 'react';
import classNames from 'classnames';
import { getAssetData, getAssetDataByAddress } from '@sovryn/contracts';
import { ChainIds } from '@sovryn/ethers-provider';
import { applyDataAttr } from '@sovryn/ui';
import styles from './AssetRenderer.module.css';
export const AssetRenderer = ({ asset, chainId = ChainIds.RSK_MAINNET, address, showAssetLogo, showLongName, assetLongNameClassName, assetClassName, className, dataAttribute, logoClassName, children, }) => {
    const [token, setToken] = useState(asset);
    const [longName, setLongName] = useState();
    const [logo, setLogo] = useState(undefined);
    useEffect(() => {
        if (asset && !address) {
            getAssetData(asset, chainId)
                .then(item => {
                setLogo(item.icon);
                setToken(item.symbol);
                setLongName(item.name);
            })
                .catch(() => setLogo(''));
        }
    }, [address, asset, chainId, showAssetLogo]);
    useEffect(() => {
        if (address && !asset) {
            getAssetDataByAddress(address, chainId)
                .then(item => {
                setLogo(item.icon);
                setToken(item.symbol);
            })
                .catch(() => setLogo(''));
        }
    }, [address, asset, chainId, showAssetLogo]);
    return (React.createElement("div", Object.assign({ className: classNames(styles.container, className) }, applyDataAttr(dataAttribute)),
        showAssetLogo && logo && (React.createElement("div", { className: classNames(styles.assetLogo, logoClassName), dangerouslySetInnerHTML: { __html: logo } })),
        React.createElement("div", { className: "flex flex-col gap-0.5" },
            React.createElement("div", { className: "flex items-center gap-2" },
                token && (React.createElement("span", { className: classNames(styles.asset, assetClassName) }, token)),
                showLongName && longName && (React.createElement("span", { className: classNames(styles.longName, assetLongNameClassName) }, longName))),
            children)));
};
